import { ifProp, prop } from 'styled-tools'
import posed from 'react-pose'
import styled from 'styled-components/macro'

const AnimatedContainer = posed.div({
  init: { scale: 1 },
  pressable: true,
  press: { scale: 1.2, transition: { duration: 200 } }
})

const Container = styled(AnimatedContainer)`
  display: flex;
  width: ${prop('size', '3.6rem')};
  height: ${prop('size', '3.6rem')};
  position: relative;
  opacity: ${ifProp('isactive', 1, 0.3)};
  cursor: ${ifProp('isactive', 'pointer', 'not-allowed')};
`

const BackgroundFill = styled.div`
  position: absolute;
  left: 0;
  background-color: ${prop('fill', 'red')};
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 100%;
  transform: scale(0.8);
`

export { BackgroundFill, Container }
